import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Animated } from "react-animated-css";
import { Input, Row, Col, Empty, Spin, Table, Descriptions, Tag } from 'antd';

import './Search.scss';

import { datagramGet } from '../../modules/datagram';

const { Search: SearchBar } = Input;
class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchResults: [],
            hasSearched: false
        };
    }

    handleSearch = (value, _e, info) => {
        const searchText = value;
        
        if (searchText.trim().length >= 2) {
            this.setState({ loading: true, hasSearched: true });
            
            // Call API through props
            this.props.datagramGet({
                text: searchText,
                env: localStorage.env,
            })
                .then(results => {
                    this.setState({ 
                        searchResults: results[0].results.map(r => {return {...r, key: r.contentId}}) || [],
                        loading: false 
                    });
                })
                .catch(error => {
                    console.error('Search error:', error);
                    this.setState({ 
                        searchResults: [],
                        loading: false 
                    });
                });
        }
    };

    render() {
        const { searchResults, loading, hasSearched } = this.state;

        const columns = [
            {
                title: 'Content ID',
                dataIndex: 'contentId',
                key: 'contentId',
                render: (text, record) => {
                    if (record._keywordMapped) {
                        return <span>{text} <Tag color="success">Keyword</Tag></span>
                    } else {
                        return text;
                    }
                }
            },
            {
                title: 'Title',
                dataIndex: 'metadata',
                key: 'metadata',
                render: (metadata) => <span>{metadata[0].title}</span>
            },
            {
                title: 'Fuzziness',
                dataIndex: 'fuzziness',
                key: 'fuzziness',
            },
            {
                title: 'Score',
                dataIndex: 'textScore',
                key: 'textScore',
                render: (textScore) => <span>{textScore.toFixed(2)}</span>
            }
        ]

        const descriptionsItem = data => {
            const { metadata, _id, key, textScore, fuzziness, ...other } = data; 
            const items = [];
            for (const [key, value] of Object.entries(data.metadata[0])) {
                items.push({
                    key: key,
                    label: key,
                    children: value?.toString()
                });
            }
            for (const [key, value] of Object.entries(other)) {
                items.push({
                    key: key,
                    label: key,
                    children: value?.toString()
                });
            }
            const keyOrder = ["contentId", "title", "contentType", "rating", 'genre', "lang", 'director', 'imageLandscape', 'imagePortrait', 'cast'];
            items.sort((a, b) => {
                const indexA = keyOrder.indexOf(a.key);
                const indexB = keyOrder.indexOf(b.key);
                return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
            });
            return items;
        }

        return (
            <Animated animationIn="fadeIn">
                <div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
                    <div className="search-container">
                        <div className="search-bar-container">
                            <div className="input-wrapper">
                                <SearchBar
                                    placeholder="input search text"
                                    allowClear
                                    enterButton="Search"
                                    size="large"
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>

                        {loading ? (
                            <div className="loading-container">
                                <Spin size="large" />
                            </div>
                        ) : hasSearched ? (
                            searchResults.length > 0 ? (
                                 <Table
                                    columns={columns}
                                    expandable={{
                                        expandedRowRender: record => <Descriptions bordered items={descriptionsItem(record)} />,
                                        rowExpandable: record => record.name !== 'Not Expandable',
                                    }}
                                    dataSource={searchResults}
                                />
                            ) : (
                                <div className="no-results">
                                    <Empty description="No results found" />
                                </div>
                            )
                        ) : null}
                    </div>
                </div>
            </Animated>
        );
    }
}

const mapStateToProps = state => ({
    router: state.router,
    userProfile: state.user.userProfile,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            datagramGet,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Search);
